import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { browserLanguage, thfLocaleDefault } from '../../../utils/util';

import { thfPageBlockedUserLiterals } from './../literals/i18n/thf-page-blocked-user-literals';
import { ThfPageBlockedUserReason } from '../enums/thf-page-blocked-user-reason.enum';
import { ThfPageBlockedUserReasonParams } from '../interfaces/thf-page-blocked-user-reason-params.interface';

@Component({
  selector: 'thf-page-blocked-user-reason',
  templateUrl: './thf-page-blocked-user-reason.component.html'
})
export class ThfPageBlockedUserReasonComponent implements OnChanges, OnInit {

  literalParams;
  literals: {title: string, firstPhrase: string, secondPhrase: string, thirdPhrase: string};

  @Input('t-params') params: ThfPageBlockedUserReasonParams;

  @Input('t-reason') reason: ThfPageBlockedUserReason;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reason || changes.params) {
      this.getLiterals();
    }
  }

  ngOnInit() {
    this.getLiterals();
  }

  getImageByReasonType() {
    let reasonImage;

    switch (this.reason) {
      case 'none': {
        reasonImage = 'big-lock';
        break;
      }
      case 'exceededAttempts': {
        reasonImage = 'blocked-user';
        break;
      }
      case 'expiredPassword': {
        reasonImage = 'expired';
        break;
      }
    }
    return `./assets/images/${reasonImage}.svg`;
  }

  getParams() {
    this.literalParams =
      this.reason === 'expiredPassword' ? [this.params.days, this.params.days] : [this.params.attempts, this.params.hours];
  }

  private getLiterals() {
    this.getParams();

    this.literals = {
      ...thfPageBlockedUserLiterals[this.reason][thfLocaleDefault],
      ...thfPageBlockedUserLiterals[this.reason][browserLanguage()],
    };

    this.changeDetector.detectChanges();
  }

}
